import { BlockOutlink } from "../Blocks/BlockOutlink";

export const WaltDisney = (props) => {
    const description = props.body ? props.body.description : '';
    return (
        <section className="walt-disney">
            <div className="block-citation">
                <div className="walt-disney-img"></div>
                <div className="citation">
                    {`«Si vous pouvez le rêver,\nvous pouvez le faire.»`}
                    <div className="author">Walter Disney</div>
                </div>
            </div>
            <div className="text">
                <div>{description}</div>
                <BlockOutlink items={props.body} />
            </div>
        </section>
    )
}